module.exports = __webpack_public_path__ + "static/media/stripes_gradient.8f719358.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stripes_gradient.jpg
// module id = 759
// module chunks = 0